import { render, staticRenderFns } from "./SeparateOrderText.vue?vue&type=template&id=7c29daa0&scoped=true&"
import script from "./SeparateOrderText.vue?vue&type=script&lang=ts&"
export * from "./SeparateOrderText.vue?vue&type=script&lang=ts&"
import style0 from "./SeparateOrderText.vue?vue&type=style&index=0&id=7c29daa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c29daa0",
  null
  
)

export default component.exports